export const templates = {
  Belly: 'Belly',
};
